(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discipline-redesign"] && !Shopify.designMode) return;
  try {
    
function initializeDisciplineDraft(root){
  if(root.dataset.initialized==='true')return;
  root.dataset.initialized='true';
  const tabs=Array.from(root.querySelectorAll('[data-preview]'));
  const panels=Array.from(root.querySelectorAll('[data-sample-panel]'));
  tabs.forEach(tab=>tab.addEventListener('click',()=>{
    tabs.forEach(item=>{const selected=item===tab;item.classList.toggle('is-active',selected);item.setAttribute('aria-pressed',String(selected));});
    panels.forEach(panel=>{panel.hidden=panel.dataset.samplePanel!==tab.dataset.preview;});
  }));
}
document.querySelectorAll('[data-dc2-store]').forEach(initializeDisciplineDraft);
document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('[data-dc2-store]').forEach(initializeDisciplineDraft);});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
